export default {"src":"/_next/static/media/back-icon.c63f4b65.svg","height":32,"width":18,"blurWidth":0,"blurHeight":0};